import { sortBy } from "lodash";

import type { Account } from "@rms-types/modules/account/entities/account";

import { getSnackbarMessages } from "@/helpers";
import { QueryFnData, useGet, UseGetOptions } from "@/hooks";

export function useGetMentions(endpoint: string, options: UseGetOptions<QueryFnData> = {}) {
  const { triggerFetchErrorMessage } = getSnackbarMessages("account");

  const {
    data: mentions = {
      "@": [],
    },
    error: mentionsError,
    isLoading: isMentionsLoading,
    ...rest
  } = useGet({
    endpoint,
    options: {
      ...options,
      enabled: !!endpoint,
      refetchOnMount: false,
      select: (data: Account[]) => {
        return {
          "@": sortBy(
            data.map(({ name, id }) => {
              return { value: name, id };
            }),
            "name"
          ),
        };
      },
      onError: (error) => {
        options.onError && options.onError(error);
        triggerFetchErrorMessage();
      },
    },
  });

  return {
    mentions,
    isMentionsLoading,
    mentionsError,
    ...rest,
  };
}
